'use client';

import { Link } from '@coolblue-development/freddy';
import selectProductTitleTrigger from '@coolblue-development/ga4-events/triggers/AddToCartPage/selectProductTitleTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useSummaryStore } from '@features/add-to-cart-page/components/SummaryStore';

type Props = {
  id: number;
  href: string;
  children: React.ReactNode;
};

export default function ProductLink({ children, id, href }: Props) {
  const { trackEvent } = useAnalytics();
  const { trackingSubFeature } = useSummaryStore();

  function onClick() {
    trackEvent(
      selectProductTitleTrigger({
        sub_feature:
          (trackingSubFeature as Parameters<typeof selectProductTitleTrigger>[0]['sub_feature']) ||
          'customer_atc_page',
        index: 1,
        total_indices: 1,
        method: 'title',
        item_id: id
      })
    );
  }

  return (
    <Link onClick={onClick} href={href}>
      {children}
    </Link>
  );
}
